import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;


if (!supabaseUrl || !supabaseAnonKey) {
  // console.error('Missing Supabase environment variables');
  // console.error('URL:', supabaseUrl);
  // console.error('Key:', supabaseAnonKey ? 'Present' : 'Missing');
  throw new Error('Missing required Supabase environment variables');
}

// Create the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false, // Don't persist session since we're using Clerk
    autoRefreshToken: false,
  }
});